<template>
  <div id="OnlinePaymentReport">
    <panel
      class="no-print"
      Title="گزارش کلیه پرداخت های اینترنتی (خود و افراد وابسته)"
      Des="از طریق این فرم می‌توانید ریز گزارشات پرداختی اینترنتی خود و افراد وابسته از طریق اینترنت بانک را مشاهده کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <net-pa-card class="no-print">
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-credit-card"></i>
          گزارش پرداخت های اینترنتی
        </h6>
      </template>
      <template slot="content">
        <div class="online-payment-report-filters">
          <div class="online-payment-report-filters__row">
            <div class="online-payment-report-field online-payment-report-field--date">
              <label class="online-payment-report-label">از تاریخ</label>
              <date-picker
                :editable="true"
                :auto-submit="true"
                :max="TaTarix"
                color="#287db4"
                v-model="AzTarixSahebHesab"
              ></date-picker>
              <input
                type="text"
                tabindex="-1"
                class="d-none InputText"
                style="direction: ltr"
              />
            </div>
            <div class="online-payment-report-field online-payment-report-field--date">
              <label class="online-payment-report-label">تا تاریخ</label>
              <date-picker
                :editable="true"
                :auto-submit="true"
                :min="AzTarix"
                color="#287db4"
                v-model="TaTarixSahebHesab"
              ></date-picker>
              <input
                type="text"
                tabindex="-1"
                class="d-none InputText"
                style="direction: ltr"
              />
            </div>
            <div class="online-payment-report-field online-payment-report-field--action">
              <span
                class="online-payment-report-label online-payment-report-label--spacer"
                aria-hidden="true"
                >&nbsp;</span
              >
              <button
                type="button"
                class="btn btn-success online-payment-report-search-btn"
                @click="
                  SearchsahebHesab();
                  $ResetTimer();
                "
              >
                <i class="fa fa-search ml-1" aria-hidden="true"></i>
                جستجو
              </button>
            </div>
          </div>
        </div>
        <div class="online-payment-report-cards" dir="rtl">
          <p v-if="!rows2.length" class="online-payment-report-cards__empty">
            اطلاعاتی یافت نشد
          </p>
          <template v-else>
            <div class="online-payment-report-cards__toolbar">
              <input
                v-model="cardSearch"
                type="search"
                class="form-control online-payment-report-cards__search"
                placeholder=" جستجو مبلغ و کد رهگیری"
                aria-label="جستجو در پرداخت‌ها"
              />
            </div>
            <p
              v-if="filteredCardRows.length === 0"
              class="online-payment-report-cards__empty"
            >
              اطلاعاتی یافت نشد
            </p>
            <div v-else class="online-payment-report-cards__list">
              <article
                v-for="(row, index) in pagedCardRows"
                :key="(row.id || 'row') + '-' + index"
                class="online-payment-report-card"
              >
                <div class="online-payment-report-card__header">
                  <strong class="online-payment-report-card__name">{{
                    row.sharh || "پرداخت اینترنتی"
                  }}</strong>
                  <span
                    v-if="row.tarixSanad"
                    class="online-payment-report-card__badge"
                    >{{ row.tarixSanad }}</span
                  >
                </div>
                <div class="online-payment-report-card__amount">
                  <span dir="ltr">{{ $Comma3ragham(row.bestan) }}</span>
                  <small>مبلغ کل واریزی</small>
                </div>
                <div class="online-payment-report-card__fields">
                  <div class="online-payment-report-card__field">
                    <span>کد رهگیری</span>
                    <strong dir="ltr">{{
                      cardValue(row.codeRahgiri)
                    }}</strong>
                  </div>
                </div>
                <div class="online-payment-report-card__actions">
                  <button
                    type="button"
                    class="online-payment-report-action Pointer"
                    @click="openPaymentDetail(row)"
                    data-toggle="modal"
                    data-target="#ModalBanafash"
                  >
                    <i class="fas fa-list" aria-hidden="true"></i>
                    جزئیات
                  </button>
                </div>
              </article>
            </div>
            <div
              v-if="filteredCardRows.length > cardPerPage"
              class="online-payment-report-cards__pager"
            >
              <button
                type="button"
                class="online-payment-report-cards__pager-btn"
                :disabled="cardPage <= 1"
                @click="cardPage = cardPage - 1"
              >
                قبلی
              </button>
              <span class="online-payment-report-cards__pager-info">
                صفحه {{ cardPage }} از {{ cardPageCount }}
              </span>
              <button
                type="button"
                class="online-payment-report-cards__pager-btn"
                :disabled="cardPage >= cardPageCount"
                @click="cardPage = cardPage + 1"
              >
                بعدی
              </button>
            </div>
          </template>
        </div>

        <div class="online-payment-report-table-view">
          <vue-bootstrap4-table
            :rows="rows2"
            :columns="columns2"
            :config="config"
            :classes="classes"
          >
            <template slot="sort-asc-icon">
              <i class="fa fa-sort-up"></i>
            </template>
            <template slot="sort-desc-icon">
              <i class="fa fa-sort-down"></i>
            </template>
            <template slot="no-sort-icon">
              <i class="fa fa-sort"></i>
            </template>
            <template slot="empty-results">
              <p class="text-right">اطلاعاتی یافت نشد</p>
            </template>
            <template slot="row" slot-scope="props">
              <p class="text-center">{{ props.row.vbt_id }}</p>
            </template>
            <template slot="bestan" slot-scope="props">
              <p class="text-center">{{ $Comma3ragham(props.row.bestan) }}</p>
            </template>
            <template slot="Action" slot-scope="props">
              <button
                type="button"
                class="online-payment-report-action Pointer"
                @click="openPaymentDetail(props.row)"
                data-toggle="modal"
                data-target="#ModalBanafash"
              >
                <i class="fas fa-list" aria-hidden="true"></i>
                جزئیات
              </button>
            </template>
          </vue-bootstrap4-table>
        </div>
      </template>
    </net-pa-card>
    <modal-custom v-if="$store.state.renderComponent">
      <template v-slot:ContentModalBanafash>
        <div class="online-payment-detail-modal" dir="rtl">
          <div class="online-payment-detail-modal__header">
            <div class="online-payment-detail-modal__intro">
              <div class="online-payment-detail-modal__intro-text">
                <h6 class="online-payment-detail-modal__title">
                  <i class="fas fa-receipt ml-2"></i>
                  جزئیات پرداخت اینترنتی
                </h6>
                <p
                  v-if="detailModalSubtitle"
                  class="online-payment-detail-modal__subtitle"
                >
                  {{ detailModalSubtitle }}
                </p>
              </div>
              <button
                type="button"
                class="online-payment-detail-modal__close close"
                data-dismiss="modal"
                aria-label="بستن"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div
              v-if="selectedPayment"
              class="online-payment-detail-modal__summary"
            >
              <div class="online-payment-detail-modal__summary-item">
                <span class="online-payment-detail-modal__summary-label"
                  >تاریخ سند</span
                >
                <span class="online-payment-detail-modal__summary-value">{{
                  selectedPayment.tarixSanad || "—"
                }}</span>
              </div>
              <div class="online-payment-detail-modal__summary-item">
                <span class="online-payment-detail-modal__summary-label"
                  >کد رهگیری</span
                >
                <span
                  class="online-payment-detail-modal__summary-value"
                  dir="ltr"
                  >{{ selectedPayment.codeRahgiri || "—" }}</span
                >
              </div>
              <div class="online-payment-detail-modal__summary-item">
                <span class="online-payment-detail-modal__summary-label"
                  >مبلغ کل</span
                >
                <span class="online-payment-detail-modal__summary-value">{{
                  $Comma3ragham(selectedPayment.bestan)
                }}</span>
              </div>
            </div>
          </div>

          <div class="online-payment-detail-modal__table-wrap table-responsive">
            <div class="online-payment-detail-cards" dir="rtl">
              <p
                v-if="!rows3.length"
                class="online-payment-detail-cards__empty"
              >
                ریز پرداختی یافت نشد
              </p>
              <template v-else>
                <div class="online-payment-detail-cards__toolbar">
                  <input
                    v-model="detailCardSearch"
                    type="search"
                    class="form-control online-payment-detail-cards__search"
                    placeholder="جستجو در ریز پرداخت‌ها"
                    aria-label="جستجو در ریز پرداخت‌ها"
                  />
                </div>
                <p
                  v-if="filteredDetailCardRows.length === 0"
                  class="online-payment-detail-cards__empty"
                >
                  ریز پرداختی یافت نشد
                </p>
                <div v-else class="online-payment-detail-cards__list">
                  <article
                    v-for="(row, index) in pagedDetailCardRows"
                    :key="(row.id || 'detail') + '-' + index"
                    class="online-payment-detail-card"
                  >
                    <div class="online-payment-detail-card__header">
                      <strong class="online-payment-detail-card__name">{{
                        row.namefamily || row.desNoe || "ریز پرداخت"
                      }}</strong>
                      <span
                        v-if="row.desNoe && row.namefamily"
                        class="online-payment-detail-card__badge"
                        >{{ row.desNoe }}</span
                      >
                    </div>
                    <div class="online-payment-detail-card__amount">
                      <span dir="ltr">{{ cardValue(row.mablagh) }}</span>
                      <small>مبلغ واریزی</small>
                    </div>
                    <div class="online-payment-detail-card__fields">
                      <div
                        v-if="row.vCode"
                        class="online-payment-detail-card__field"
                      >
                        <span>شماره حساب/تسهیلات</span>
                        <strong dir="ltr">{{ row.vCode }}</strong>
                      </div>
                      <div
                        v-if="row.desNoe && !row.namefamily"
                        class="online-payment-detail-card__field"
                      >
                        <span>عنوان</span>
                        <strong>{{ row.desNoe }}</strong>
                      </div>
                    </div>
                  </article>
                </div>
                <div
                  v-if="filteredDetailCardRows.length > detailCardPerPage"
                  class="online-payment-detail-cards__pager"
                >
                  <button
                    type="button"
                    class="online-payment-detail-cards__pager-btn"
                    :disabled="detailCardPage <= 1"
                    @click="detailCardPage = detailCardPage - 1"
                  >
                    قبلی
                  </button>
                  <span class="online-payment-detail-cards__pager-info">
                    صفحه {{ detailCardPage }} از {{ detailCardPageCount }}
                  </span>
                  <button
                    type="button"
                    class="online-payment-detail-cards__pager-btn"
                    :disabled="detailCardPage >= detailCardPageCount"
                    @click="detailCardPage = detailCardPage + 1"
                  >
                    بعدی
                  </button>
                </div>
              </template>
            </div>

            <div class="online-payment-detail-table-view">
            <vue-bootstrap4-table
              :rows="rows3"
              :columns="columns3"
              :config="detailModalConfig"
              :classes="detailModalClasses"
            >
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="online-payment-detail-modal__empty">
                  ریز پرداختی یافت نشد
                </p>
              </template>
              <template slot="mablagh" slot-scope="props">
                <span class="online-payment-detail-modal__amount">{{
                  props.cell_value
                }}</span>
              </template>
              <template slot="vCode" slot-scope="props">
                <span dir="ltr">{{ props.cell_value }}</span>
              </template>
            </vue-bootstrap4-table>
            </div>
          </div>

          <div v-if="rows3.length" class="online-payment-detail-modal__footer">
            <span class="online-payment-detail-modal__footer-label">
              مجموع ریز پرداخت‌ها:
              <strong>{{ $Comma3ragham(detailTotalMablagh) }}</strong>
              {{ $GetVahedPool() }}
            </span>
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import ModalCustom from "../Tools/ModalCustom.vue";
export default {
  components: {
    NetPaCard,
    Panel,
    VueBootstrap4Table,
    ModalCustom,
  },
  data() {
    return {
      AzTarix: "",
      TaTarix: "",

      AzTarixSahebHesab: "",
      TaTarixSahebHesab: "",

      DataAxiosRow: {
        ArryfildValue: "",
        Method: "Post",
        Action: "GozareshParForWeb",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosRow_SahebHesab: {
        ArryfildValue: "",
        Method: "Post",
        Action: "GozareshParForWeb/GetGozareshSahebHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosRow_Detaile: {
        ArryfildValue: "",
        Method: "Post",
        Action: "GozareshParForWeb/Detaile",
        Token: this.$session.get("TokenNetPa"),
      },
      rows: [],
      rows2: [],
      rows3: [],
      cardSearch: "",
      cardPage: 1,
      cardPerPage: 10,
      detailCardSearch: "",
      detailCardPage: 1,
      detailCardPerPage: 5,
      selectedPayment: null,
      detailTotalMablagh: 0,
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "ردیف",
          name: "row",
        },

        {
          label: "عنوان تسهیلات",
          name: "desNoe",
        },
        {
          label: "شماره تسهیلات",
          name: "vCode",
        },
        {
          label: "مبلغ واریزی",
          name: "bestan",
        },
        {
          label: "زمان تراکنش",
          name: "zamanInsert",
        },
        {
          label: "تاریخ سند",
          name: "tarixSanad",
        },
        {
          label: "کد رهگیری",
          name: "codeRahgiri",
        },
        {
          label: "شرح واریزی",
          name: "sharhSanad",
        },
      ],
      columns2: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "ردیف",
          name: "row",
        },

        {
          label: "شرح واریزی",
          name: "sharh",
        },
        {
          label: "تاریخ سند",
          name: "tarixSanad",
        },
        {
          label: "کد رهگیری",
          name: "codeRahgiri",
        },
        {
          label: "مبلغ کل واریزی",
          name: "bestan",
        },
        {
          label: "عملیات",
          name: "Action",
        },
      ],
      columns3: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "ردیف",
          name: "row",
        },

        {
          label: "مبلغ واریزی",
          name: "mablagh",
        },
        {
          label: "شماره حساب/تسهیلات",
          name: "vCode",
        },
        {
          label: "عنوان حساب/تسهیلات",
          name: "desNoe",
        },
        {
          label: "مشخصات",
          name: "namefamily",
        },
      ],
      config: {
        pagination: true,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: "  جستجو مبلغ و کد رهگیری",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      detailModalConfig: {
        pagination: true,
        pagination_info: false,
        per_page: 5,
        per_page_options: [5, 10, 20],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: false,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: "جستجو در ریز پرداخت‌ها",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 500,
        },
      },
      detailModalClasses: {
        table: "table table-hover online-payment-detail-modal-table",
      },
    };
  },
  computed: {
    detailModalSubtitle() {
      if (!this.selectedPayment) return "";
      return this.selectedPayment.sharh || "";
    },
    filteredCardRows() {
      const q = (this.cardSearch || "").trim().toLowerCase();
      if (!q) return this.rows2;
      return this.rows2.filter((row) => {
        const hay = [
          row.row,
          row.sharh,
          row.tarixSanad,
          row.codeRahgiri,
          row.bestan,
        ]
          .filter((v) => v != null && v !== "")
          .join(" ")
          .toLowerCase();
        return hay.includes(q);
      });
    },
    pagedCardRows() {
      const start = (this.cardPage - 1) * this.cardPerPage;
      return this.filteredCardRows.slice(start, start + this.cardPerPage);
    },
    cardPageCount() {
      return Math.max(
        1,
        Math.ceil(this.filteredCardRows.length / this.cardPerPage),
      );
    },
    filteredDetailCardRows() {
      const q = (this.detailCardSearch || "").trim().toLowerCase();
      if (!q) return this.rows3;
      return this.rows3.filter((row) => {
        const hay = [row.row, row.mablagh, row.vCode, row.desNoe, row.namefamily]
          .filter((v) => v != null && v !== "")
          .join(" ")
          .toLowerCase();
        return hay.includes(q);
      });
    },
    pagedDetailCardRows() {
      const start = (this.detailCardPage - 1) * this.detailCardPerPage;
      return this.filteredDetailCardRows.slice(
        start,
        start + this.detailCardPerPage,
      );
    },
    detailCardPageCount() {
      return Math.max(
        1,
        Math.ceil(this.filteredDetailCardRows.length / this.detailCardPerPage),
      );
    },
  },
  watch: {
    rows2() {
      this.cardPage = 1;
    },
    cardSearch() {
      this.cardPage = 1;
    },
    rows3() {
      this.detailCardPage = 1;
    },
    detailCardSearch() {
      this.detailCardPage = 1;
    },
  },
  mounted() {
    this.SearchsahebHesab();
  },
  methods: {
    cardValue(val) {
      if (val == null || val === "") return "—";
      return val;
    },
    SearchGardesh() {
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append("AzTarix", this.AzTarix);
      formData.append("TaTarix", this.TaTarix);
      this.DataAxiosRow.ArryfildValue = formData;

      this.$PostFormData(this.DataAxiosRow).then((data) => {
        this.rows = data.result;
      });
    },
    SearchsahebHesab() {
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append("AzTarix", this.AzTarixSahebHesab);
      formData.append("TaTarix", this.TaTarixSahebHesab);
      this.DataAxiosRow_SahebHesab.ArryfildValue = formData;

      this.$PostFormData(this.DataAxiosRow_SahebHesab).then((data) => {
        this.rows2 = data.result;
      });
    },
    openPaymentDetail(row) {
      this.selectedPayment = row;
      this.detailCardSearch = "";
      this.detailCardPage = 1;
      this.Detaile(row.id);
    },
    Detaile(id) {
      let info;
      let list = [];
      this.$store.state.renderComponent = false;
      this.$nextTick(() => {
        this.$store.state.renderComponent = true;
      });

      const applyDetail = (result) => {
        this.detailTotalMablagh = result.reduce(
          (sum, item) => sum + (Number(item.mablagh) || 0),
          0,
        );
        for (let index = 0; index < result.length; index++) {
          info = result[index];
          info["row"] = index + 1;
          list.push(info);
        }
        this.rows3 = this.$FormatMablaghGrid(list);
      };

      const formData = new FormData();
      formData.append("wwwtblVarizGorohiId", id);
      this.DataAxiosRow_Detaile.ArryfildValue = formData;

      this.$PostFormData(this.DataAxiosRow_Detaile).then((data) => {
        applyDetail(data.result);
      });
    },
  },
};
</script>
<style scoped>
.online-payment-report-filters {
  width: 100%;
  margin: 0 0 1rem;
  padding: 0 0 1rem;
  border-bottom: 1px solid #e8eef2;
}

.online-payment-report-filters__row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 0.75rem;
  width: 100%;
}

.online-payment-report-field {
  display: flex;
  flex: 0 1 11.5rem;
  flex-direction: column;
  min-width: 10rem;
  text-align: right;
}

.online-payment-report-field--action {
  flex: 0 0 auto;
  min-width: 0;
}

.online-payment-report-label {
  display: block;
  margin-bottom: 0.35rem;
  min-height: 1.25rem;
  color: #29345f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px !important;
  font-weight: 700;
  line-height: 1.25rem;
}

.online-payment-report-label--spacer {
  visibility: hidden;
  user-select: none;
}

.online-payment-report-field--date >>> .vpd-main {
  display: block;
  width: 100%;
}

.online-payment-report-field--date >>> .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 40px;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.online-payment-report-field--date >>> .vpd-input-group:focus-within {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

.online-payment-report-field--date >>> .vpd-input-group input,
.online-payment-report-field--date >>> .vpd-input-group input.form-control {
  width: 100%;
  min-width: 0;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0.4rem 0.75rem;
  border: none !important;
  border-radius: 0 !important;
  background: transparent;
  box-shadow: none !important;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
}

.online-payment-report-field--date >>> .vpd-input-group .vpd-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.4rem;
  margin: 0 !important;
  padding: 0 0.6rem !important;
  color: #287db4;
  border: none;
  background: #edf5fb;
}

.online-payment-report-search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 6.75rem;
  min-height: 40px;
  height: 40px;
  margin: 0;
  padding: 0 1rem;
  border-radius: 12px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
}

.online-payment-report-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 32px;
  margin: 0;
  padding: 0.3rem 0.75rem;
  color: #287db4;
  border: 1px solid #cfe4f2;
  border-radius: 10px;
  background: #edf5fb;
  box-shadow: 0 1px 2px rgba(41, 52, 95, 0.05);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease;
}

.online-payment-report-action i {
  font-size: 11px;
}

.online-payment-report-action:hover,
.online-payment-report-action:focus {
  color: #fff;
  border-color: #287db4;
  background: #287db4;
  outline: none;
}

@media (max-width: 767px) {
  .online-payment-report-field,
  .online-payment-report-field--action {
    flex: 1 1 100%;
    min-width: 0;
  }

  .online-payment-report-search-btn {
    width: 100%;
  }
}

.online-payment-report-cards,
.online-payment-detail-cards {
  display: none;
}

.online-payment-report-cards__toolbar,
.online-payment-detail-cards__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  margin: 0 0 0.85rem;
}

.online-payment-report-cards__search,
.online-payment-detail-cards__search {
  flex: 1 1 12rem;
  min-width: 0;
  min-height: 40px;
  padding: 0.45rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #dce1e8;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(42, 63, 84, 0.06);
}

.online-payment-report-cards__search:focus,
.online-payment-detail-cards__search:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

.online-payment-report-cards__empty,
.online-payment-detail-cards__empty {
  margin: 0.75rem 0 0;
  padding: 1.5rem 1rem;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  border: 1px dashed #dbe5eb;
  border-radius: 14px;
  background: #f8fafc;
}

.online-payment-report-cards__list,
.online-payment-detail-cards__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.online-payment-report-card,
.online-payment-detail-card {
  padding: 0.95rem 1rem 0.9rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
}

.online-payment-report-card__header,
.online-payment-detail-card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.55rem;
}

.online-payment-report-card__name,
.online-payment-detail-card__name {
  min-width: 0;
  color: #13243a;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.45;
}

.online-payment-report-card__badge,
.online-payment-detail-card__badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0.15rem 0.65rem;
  border-radius: 999px;
  color: #287db4;
  background: #edf5fb;
  font-size: 12px;
  font-weight: 800;
}

.online-payment-report-card__amount,
.online-payment-detail-card__amount {
  margin: 0 0 0.75rem;
  color: #29345f;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.3;
}

.online-payment-report-card__amount small,
.online-payment-detail-card__amount small {
  margin-right: 0.3rem;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.online-payment-report-card__fields,
.online-payment-detail-card__fields {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.online-payment-report-card__field,
.online-payment-detail-card__field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

.online-payment-report-card__field span,
.online-payment-detail-card__field span {
  flex-shrink: 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.online-payment-report-card__field strong,
.online-payment-detail-card__field strong {
  min-width: 0;
  color: #13243a;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.online-payment-report-card__actions {
  display: flex;
  margin-top: 0.75rem;
}

.online-payment-report-card__actions .online-payment-report-action {
  width: 100%;
  min-height: 40px;
  border-radius: 12px;
}

.online-payment-report-cards__pager,
.online-payment-detail-cards__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-top: 0.85rem;
}

.online-payment-report-cards__pager-btn,
.online-payment-detail-cards__pager-btn {
  min-height: 34px;
  padding: 0.3rem 0.85rem;
  color: #29345f;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.online-payment-report-cards__pager-btn:disabled,
.online-payment-detail-cards__pager-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.online-payment-report-cards__pager-info,
.online-payment-detail-cards__pager-info {
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

@media (max-width: 767px) {
  .online-payment-report-cards,
  .online-payment-detail-cards {
    display: block;
  }

  .online-payment-report-table-view,
  .online-payment-detail-table-view {
    display: none;
  }
}

#OnlinePaymentReport >>> #ModalBanafash .modal-dialog {
  margin: 1.25rem auto;
  max-width: min(920px, calc(100vw - 2rem));
  width: calc(100% - 2rem);
}

#OnlinePaymentReport >>> #ModalBanafash .modal-content {
  background: #fff !important;
  border: none;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(42, 63, 84, 0.18);
  overflow: hidden;
  max-height: min(calc(100dvh - 1.5rem), calc(100vh - 1.5rem));
}

#OnlinePaymentReport >>> #ModalBanafash .modal-header.bg {
  display: none !important;
  height: 0 !important;
  min-height: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  overflow: hidden;
}

#OnlinePaymentReport >>> #ModalBanafash .modal-body {
  padding: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: min(calc(100dvh - 1.5rem), calc(100vh - 1.5rem));
  overflow: hidden;
}

#OnlinePaymentReport .online-payment-detail-modal {
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: min(calc(100dvh - 1.5rem), calc(100vh - 1.5rem));
  background: #fff;
  text-align: right;
  border-radius: 14px;
  overflow: hidden;
}

#OnlinePaymentReport .online-payment-detail-modal__header {
  flex-shrink: 0;
  padding: 0.75rem 0.85rem 0.65rem;
  border-bottom: 1px solid #e8ecf1;
}

#OnlinePaymentReport .online-payment-detail-modal__intro {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.65rem;
}

#OnlinePaymentReport .online-payment-detail-modal__intro-text {
  flex: 1 1 auto;
  min-width: 0;
}

#OnlinePaymentReport .online-payment-detail-modal__close {
  flex-shrink: 0;
  align-self: flex-start;
  float: none;
  margin: 0 0 0 -0.45rem;
  padding: 0;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(42, 63, 84, 0.08);
  color: #2a3f54 !important;
  opacity: 1;
  text-shadow: none;
  font-size: 1.35rem;
  line-height: 1;
}

#OnlinePaymentReport .online-payment-detail-modal__close:hover {
  background: rgba(42, 63, 84, 0.14);
  color: #1a2a3a !important;
}

#OnlinePaymentReport .online-payment-detail-modal__close:focus,
#OnlinePaymentReport .online-payment-detail-modal__close:focus-visible,
#OnlinePaymentReport .online-payment-detail-modal__close:active {
  outline: none !important;
  box-shadow: none !important;
}

#OnlinePaymentReport .online-payment-detail-modal__title {
  margin: 0;
  min-width: 0;
  font-size: 15px !important;
  font-weight: 700;
  color: #2a3f54;
  line-height: 1.5;
}

#OnlinePaymentReport .online-payment-detail-modal__title .fa-receipt {
  color: #2563eb;
}

#OnlinePaymentReport .online-payment-detail-modal__subtitle {
  margin: 0.35rem 0 0;
  font-size: 12px !important;
  font-weight: 600;
  color: #6c757d;
  line-height: 1.4;
}

#OnlinePaymentReport .online-payment-detail-modal__summary {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  width: 100%;
  margin-top: 0.55rem;
}

#OnlinePaymentReport .online-payment-detail-modal__summary-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  min-height: 2.35rem;
  background: #f8fafc;
  border: 1px solid #e8ecf1;
  border-radius: 8px;
  padding: 0.5rem 0.65rem;
  min-width: 0;
}

#OnlinePaymentReport .online-payment-detail-modal__summary-label {
  flex-shrink: 0;
  font-size: 12px !important;
  font-weight: 600;
  color: #6c757d;
  margin: 0;
  white-space: nowrap;
}

#OnlinePaymentReport .online-payment-detail-modal__summary-value {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px !important;
  font-weight: 700;
  color: #2a3f54;
  text-align: left;
  margin: 0;
  word-break: break-word;
}

#OnlinePaymentReport .online-payment-detail-modal__table-wrap {
  flex: 1 1 auto;
  min-height: 0;
  padding: 0.5rem 0.75rem 0.35rem;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

#OnlinePaymentReport
  .online-payment-detail-modal__table-wrap
  >>> .vbt-table-wrapper {
  overflow-x: auto;
  overflow-y: visible;
  max-height: none;
}

#OnlinePaymentReport .online-payment-detail-modal-table {
  margin-bottom: 0;
  font-size: 13px !important;
}

#OnlinePaymentReport .online-payment-detail-modal-table thead th {
  background: #f0f2f5;
  color: #2a3f54;
  font-weight: 700;
  border-color: #e8ecf1;
  white-space: nowrap;
}

#OnlinePaymentReport .online-payment-detail-modal-table tbody td {
  vertical-align: middle;
  color: #2a3f54;
}

#OnlinePaymentReport .online-payment-detail-modal__amount {
  font-weight: 700;
  color: #15803d;
}

#OnlinePaymentReport .online-payment-detail-modal__empty {
  margin: 0;
  padding: 1.5rem 0;
  text-align: center;
  color: #6c757d;
}

#OnlinePaymentReport .online-payment-detail-modal__footer {
  flex-shrink: 0;
  padding: 0.65rem 0.75rem 0.75rem;
  border-top: 1px solid #e8ecf1;
  background: #fafbfc;
  text-align: right;
}

#OnlinePaymentReport .online-payment-detail-modal__footer-label {
  font-size: 15px !important;
  font-weight: 700;
  color: #2a3f54;
  line-height: 1.5;
}

#OnlinePaymentReport .online-payment-detail-modal__footer-label strong {
  font-size: 16px !important;
  font-weight: 800;
  color: #15803d;
}

#OnlinePaymentReport
  .online-payment-detail-modal__table-wrap
  >>> .vbt-global-search-wrapper {
  max-width: 20rem;
}

@media (max-width: 767px) {
  #OnlinePaymentReport >>> #ModalBanafash .modal-dialog {
    margin: 0.5rem auto;
    width: calc(100% - 0.75rem);
    max-width: calc(100% - 0.75rem);
  }

  #OnlinePaymentReport >>> #ModalBanafash .modal-content,
  #OnlinePaymentReport >>> #ModalBanafash .modal-body,
  #OnlinePaymentReport .online-payment-detail-modal {
    max-height: min(calc(100dvh - 1rem), calc(100vh - 1rem));
  }

  #OnlinePaymentReport .online-payment-detail-modal__header {
    padding: 0.6rem 0.65rem 0.5rem;
  }

  #OnlinePaymentReport .online-payment-detail-modal__intro {
    gap: 0.45rem;
  }

  #OnlinePaymentReport .online-payment-detail-modal__close {
    width: 28px;
    height: 28px;
    margin-left: -0.35rem;
    font-size: 1.2rem;
  }

  #OnlinePaymentReport .online-payment-detail-modal__title {
    font-size: 14px !important;
    line-height: 1.35;
  }

  #OnlinePaymentReport .online-payment-detail-modal__subtitle {
    margin-top: 0.25rem;
    font-size: 11px !important;
  }

  #OnlinePaymentReport .online-payment-detail-modal__summary {
    margin-top: 0.45rem;
    gap: 0.35rem;
  }

  #OnlinePaymentReport .online-payment-detail-modal__summary-item {
    min-height: 2.15rem;
    padding: 0.45rem 0.55rem;
    border-radius: 6px;
  }

  #OnlinePaymentReport .online-payment-detail-modal__summary-label {
    font-size: 11px !important;
  }

  #OnlinePaymentReport .online-payment-detail-modal__summary-value {
    font-size: 12px !important;
  }

  #OnlinePaymentReport .online-payment-detail-modal__table-wrap {
    padding: 0.4rem 0.55rem 0.25rem;
  }

  #OnlinePaymentReport .online-payment-detail-modal-table {
    font-size: 12px !important;
  }

  #OnlinePaymentReport .online-payment-detail-modal__footer {
    padding: 0.55rem 0.55rem 0.6rem;
  }

  #OnlinePaymentReport .online-payment-detail-modal__footer-label {
    font-size: 14px !important;
    font-weight: 700;
    line-height: 1.45;
  }

  #OnlinePaymentReport .online-payment-detail-modal__footer-label strong {
    font-size: 15px !important;
    font-weight: 800;
  }

  #OnlinePaymentReport
    .online-payment-detail-modal__table-wrap
    >>> .vbt-table-tools {
    --vbt-search-max-width: 100%;
  }

  #OnlinePaymentReport
    .online-payment-detail-modal__table-wrap
    >>> .vbt-global-search-wrapper {
    max-width: 100%;
  }

  #OnlinePaymentReport
    .online-payment-detail-modal__table-wrap
    >>> .footer-pagination-row
    > td {
    padding: 0.55rem 0.45rem !important;
  }

  #OnlinePaymentReport
    .online-payment-detail-modal__table-wrap
    >>> .vbt-pagination-row
    .pagination {
    justify-content: center;
    gap: 0.25rem;
  }
}
</style>
